<div class="information">
  <i class="fas fa-question-circle"></i>
  <p [class]="otherClass">{{ text }}</p>
</div>
